import styled from "styled-components";

export const Paso4Container = styled.div`
  width: 100%;
  padding: 0 20px;
  .ValidaTurno-separador {
    height: 2px;
    margin: 20px;
    background-color: var(--color-grey95);
  }
  .loading-spinner-container {
    margin: auto;
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const Paso4ContainerPaso = styled.div`
  padding: 0 14px;
`;
export const Paso4Titulo = styled.div`
  display: flex;
  justify-content: center;
`;

export const Paso4Body = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  .ValidaTurno-bodytxt {
    text-align: center;
  }
  .ValidaTurno-input {
    width: 190px;
  }
`;
export const Paso4ContainerBotones = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  .btn-validaturno {
    padding: 10px;
    min-width: 156px;
    height: 54px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn-outline-validaturno {
    border: 2px var(--color-latex30) solid;
  }
  @media (max-height: 700px) {
    margin-top: 5px;
  }
`;
